import React, { PropsWithChildren, Suspense } from 'react'
import { Transition } from '@headlessui/react'
import classNames from 'classnames'
import { AppFeatures } from '@/experimentation/app-features'
import { Experiment } from '../Experiment'

export interface Props<T extends keyof AppFeatures> extends PropsWithChildren {
  as?: React.ElementType
  experimentName: T
  defaultValue: AppFeatures[T]
  fallbackClassName?: string
  className?: string
  fallbackComponent?: React.ReactElement | null
  children: React.ReactNode
  enterClassName?: string
  leaveClassName?: string
}

export function FadeInExperiment<T extends keyof AppFeatures>({
  as,
  experimentName,
  defaultValue,
  fallbackClassName,
  className,
  fallbackComponent,
  children,
  enterClassName = 'transition-opacity duration-1000',
  leaveClassName = 'transition-opacity duration-1000',
}: Props<T>) {
  return (
    <Suspense fallback={<div className={classNames(fallbackClassName)}>{fallbackComponent ?? null}</div>}>
      <Transition
        show
        appear
        className={className}
        enter={enterClassName}
        enterFrom="opacity-0"
        enterTo="opacity-100"
        leave={leaveClassName}
        leaveFrom="opacity-100"
        leaveTo="opacity-0"
        as={as}
      >
        <Experiment experimentName={experimentName} defaultValue={defaultValue}>
          {children}
        </Experiment>
      </Transition>
    </Suspense>
  )
}
